module.exports = __webpack_public_path__ + "img/Picture31.8f330fd8.png";